<script setup>
import { useForm } from '@inertiajs/vue3';
import AppFooter from '@/Components/AppFooter.vue';

const props = defineProps({
    status: String,
});

const form = useForm({ email: '', password: '' });
</script>

<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100">
        <form @submit.prevent="form.post('/login')" class="p-8 bg-white shadow-md rounded-lg w-96">
            <h2 class="text-2xl font-bold mb-6 text-center">{{ $t('auth.login_title') }}</h2>

            <div v-if="status" class="mb-4 text-sm text-green-600 bg-green-50 border border-green-200 rounded p-3">
                {{ status }}
            </div>

            <input v-model="form.email" type="email" :placeholder="$t('placeholder.email')" class="w-full mb-1 p-2 border rounded" :class="{ 'border-red-500': form.errors.email }" />
            <p v-if="form.errors.email" class="text-red-500 text-xs mb-3">{{ form.errors.email }}</p>
            <div v-else class="mb-4" />

            <input v-model="form.password" type="password" :placeholder="$t('placeholder.password')" class="w-full mb-6 p-2 border rounded" />

            <button type="submit" :disabled="form.processing" class="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-50">{{ $t('button.login') }}</button>

            <div class="mt-4 text-center">
                <a href="/forgot-password" class="text-sm text-blue-600 hover:underline">{{ $t('auth.forgot_password_link') }}</a>
            </div>
        </form>
        <AppFooter />
    </div>
</template>